import React, { ReactNode } from 'react';
import { T } from 'app/components/localization';
import { createStyles } from '../../utils/css';
import BaseButton from 'app/components/common/BaseButton';
import X from 'app/components/svgs/X';

const ModalTitle = ({ children, onClose }: { children: ReactNode, onClose?: () => void }) =>
  <T>{t =>
    <Styles>{(css) =>
      <div className={css('container')}>
        <div className={css('title')}>{children}</div>
        {onClose &&
          <div className={css('close')}>
            <BaseButton aria-label={t('modal.close')} className={css('button')} onClick={onClose}>
              <X />
            </BaseButton>
          </div>}
      </div>
    }</Styles>
  }</T>;

const Styles = createStyles({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 0,
    justifyContent: 'space-around',
    padding: '1em 1em 0 1em',
  },
  title: {
    fontWeight: 600,
    flexGrow: 1,
  },
  button: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    boxSizing: 'content-box',
    padding: '0.25em',
    display: 'flex',
    width: '0.5em',
  },
  close: {
    flexGrow: 0,
    flexShrink: 0,
    marginLeft: '1em',
  },
});

export default ModalTitle;
